export const checkIsTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

export const isTouchDevice = checkIsTouchDevice();
